module.exports = __webpack_public_path__ + "3aac39fcc745c5922c3230353b74d991.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/painted-nails-pink-s.png
// module id = 1903
// module chunks = 0